export default function () {
  return {
    form: {
      id: null,
      chat: 0,
      title: "",
      description: "",
      logo: null,
      banner: null,
      product_sections: [],
      is_storeFront: false,
      is_company_owns: true,
    },

    loadedBrands: {},
  };
}
